export default { sha: 'e99365db0577140c957521620930a2932712806a', buildNumber: 'undefined' }
